/**
 * Breadcrumb navigation context.
 *
 * Follow-route mode: nav anchors carry data-nav-key; the ?nav=<key> param is
 * appended at click time only, so crawlers see a clean internal-link graph.
 * On PLPs the effective key (validated ?nav, else the PLP's own default node)
 * is forwarded onto product-card clicks via a delegated listener — facets.js
 * replaces #ProductGridContainer innerHTML on every filter change, so per-card
 * href rewriting would not survive.
 *
 * The visible-trail swap itself is NOT here — it is a synchronous inline
 * script in breadcrumb-engine.liquid so it runs pre-paint.
 */
(function () {
  var mode = (document.currentScript && document.currentScript.dataset.mode) || 'follow_route';
  var followRoute = mode !== 'always_default';

  function appendNav(anchor, key) {
    if (!key) return;
    // An inert nav node (no destination) renders WITHOUT href — the .href
    // property then reads "" and would resolve to the origin root, so this
    // handler minted href="/?nav=<key>" mid-click and the browser followed it
    // to the homepage. Never give an href to an anchor that has none. AAS-5493
    if (!anchor.hasAttribute('href')) return;
    try {
      var url = new URL(anchor.href, location.origin);
      if (url.origin !== location.origin) return;
      url.searchParams.set('nav', key);
      anchor.href = url.toString();
    } catch (e) {
      /* unparseable href (e.g. "#") — leave it alone */
    }
  }

  function onNavigate(handler) {
    ['click', 'auxclick'].forEach(function (type) {
      document.addEventListener(type, handler, true);
    });
  }

  if (followRoute) {
    onNavigate(function (event) {
      if (!event.target || !event.target.closest) return;

      var navLink = event.target.closest('a[data-nav-key]');
      if (navLink) {
        appendNav(navLink, navLink.dataset.navKey);
        return;
      }

      // Mobile drawer "shop all" header link: its href is set by the drawer JS
      // from the active panel; the panel carries the nav key.
      var shopAll = event.target.closest('a.nav-drawer__shop-all');
      if (shopAll) {
        var panel = document.querySelector('.nav-drawer__panel.is-active[data-nav-key]');
        if (panel) appendNav(shopAll, panel.dataset.navKey);
      }
    });
  }

  var plpNav = document.querySelector('nav[data-breadcrumb-context="collection"]');
  if (plpNav && followRoute) {
    var effectiveKey = null;
    try {
      var param = new URLSearchParams(location.search).get('nav');
      if (param) {
        var mapEl = plpNav.querySelector('[data-breadcrumb-trails]');
        var trails = mapEl ? JSON.parse(mapEl.textContent) : {};
        if (trails[param.toLowerCase()]) effectiveKey = param.toLowerCase();
      }
    } catch (e) {
      /* malformed ?nav or trails JSON — fall back to the default key */
    }
    if (!effectiveKey) effectiveKey = plpNav.dataset.defaultNavKey || null;

    if (effectiveKey) {
      onNavigate(function (event) {
        if (!event.target || !event.target.closest) return;
        var productLink = event.target.closest('#ProductGridContainer a[href*="/products/"]');
        if (productLink) appendNav(productLink, effectiveKey);
      });
    }
  }
})();
